module.exports = __webpack_public_path__ + "0863460f0ca8c2994ce23124b9a3c50c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NonAuthHomePage/components/Description/images/mob2_3x.png
// module id = Ue8w
// module chunks = 13